import styled from 'styled-components';
import * as bp from 'view/styles/breakpoints';
import { token } from '@atlaskit/tokens';

const presentationImageTopPadding = '130px';

export const PageWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: ${token('space.1000', '80px')} ${token('space.400', '32px')};
`;

export const HelpDeskFormPresentation = styled.img`
    object-fit: contain;
    max-width: 100%;
`;

export const ImgWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    height: 100%;

    ${bp.fromSmall.css`
        padding-top: ${presentationImageTopPadding};
    `}
`;
